/* ==========================================================================
   Gleva · Direction B · social proof JS (port of final-b2/_src/sp2/reviews.js; SPEC _work/sp2/reviews/SPEC.md)
   Customer reviews [data-rvw]: star-distribution filter, attribute / photo chips, sort, "Show more", Read more.
   Customer photos [data-cph]: desktop rail arrows + progress, "View all" sheet.
   Photo lightbox: one <dialog class="rlb gvb"> built on first use ([data-rlb-item] inside a [data-rlb-group]).
   Buy-box rating line [data-bbr]: moves focus to the reviews heading after the jump.
   Reviews are section blocks (rendered cards), so filtering and sorting work on the rendered cards.
   Global: window.gvbReviewsInit(scope). Re-inits on shopify:section:load (theme editor).
   ========================================================================== */
(function () {
  'use strict';
  if (window.gvbReviewsInit) return;                                       // both sections include this file
  var DESK = window.matchMedia('(min-width:1024px)');
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ICON = {
    arrow: '<svg class="ico" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    close: '<svg class="ico" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m6 6 12 12M18 6 6 18"/></svg>',
    badge: '<svg class="ico" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 3.2 14.2 5l2.8-.2.7 2.7 2.4 1.5-1 2.6 1 2.6-2.4 1.5-.7 2.7-2.8-.2L12 20.8 9.8 19l-2.8.2-.7-2.7-2.4-1.5 1-2.6-1-2.6 2.4-1.5.7-2.7 2.8.2L12 3.2Z"/><path d="m8.8 12.2 2.2 2.2 4.2-4.4"/></svg>'
  };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function starFill(r) { r = +r || 0; if (r >= 5) return 100; if (r <= 0) return 0; var f = Math.floor(r); return Math.round((f * 27 + (r - f) * 24) / 132 * 10000) / 100; }
  function fmt(n) { return Number(n).toLocaleString('en-IN'); }

  /* ------------------------------------------------------------ shared sheet dialogs */
  function openDialog(d, opener) {
    if (!d) return;
    d._opener = opener || document.activeElement;
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
  }
  function closeDialog(d) { if (!d) return; if (d.open && typeof d.close === 'function') d.close(); else d.removeAttribute('open'); }
  function wireDialog(d) {
    if (!d || d._wired) return; d._wired = true;
    d.addEventListener('click', function (e) {
      if (e.target === d) closeDialog(d);                                  // scrim (the dialog box itself, outside its content)
      if (e.target.closest('[data-gsheet-close]')) closeDialog(d);
    });
    d.addEventListener('close', function () { var o = d._opener; if (o && o.focus && document.contains(o)) o.focus({ preventScroll: true }); });
  }

  /* ------------------------------------------------------------ REVIEWS */
  function initReviews(sec) {
    sec.setAttribute('data-rvw-ready', '');
    var list = $('[data-rvw-list]', sec);
    if (!list) return;                                                     // app block only (fewer than 3 typed reviews): nothing to wire
    var cards = $$('.rvw-card', list);
    var order = cards.slice();                                             // app order = most recent first
    var total = +sec.getAttribute('data-total') || cards.length;
    var pageM = +sec.getAttribute('data-page') || 3, pageD = +sec.getAttribute('data-page-d') || 4;
    var dist = $('[data-rvw-dist]', sec);
    var bars = $$('[data-rvw-star]', sec);
    var chips = $$('[data-rvw-attr]', sec), photoChip = $('[data-rvw-photos]', sec), topics = $$('[data-rvw-topic]', sec);
    var sortSel = $('[data-rvw-sort]', sec);
    var countEl = $('[data-rvw-count]', sec), clearBtns = $$('[data-rvw-clear]', sec);
    var none = $('[data-rvw-none]', sec), moreWrap = $('[data-rvw-more-wrap]', sec), moreBtn = $('[data-rvw-more-btn]', sec);
    var st = { stars: [], attr: '', photos: false, topic: '', sort: 'recent', limit: page() };
    function page() { return DESK.matches ? pageD : pageM; }
    function filtered() { return st.stars.length || st.attr || st.photos || st.topic; }

    function matches(c) {
      if (st.stars.length && st.stars.indexOf(+c.getAttribute('data-rating')) < 0) return false;
      if (st.attr && c.getAttribute('data-attr') !== st.attr) return false;
      if (st.photos && !(+c.getAttribute('data-photos'))) return false;
      if (st.topic && (' ' + c.getAttribute('data-topics') + ' ').indexOf(' ' + st.topic + ' ') < 0) return false;
      return true;
    }
    function sorted(arr) {
      var a = arr.slice(), idx = function (c) { return order.indexOf(c); };
      if (st.sort === 'high') a.sort(function (x, y) { return (+y.dataset.rating - +x.dataset.rating) || (idx(x) - idx(y)); });
      else if (st.sort === 'low') a.sort(function (x, y) { return (+x.dataset.rating - +y.dataset.rating) || (idx(x) - idx(y)); });
      else if (st.sort === 'photos') a.sort(function (x, y) { return ((+y.dataset.photos > 0) - (+x.dataset.photos > 0)) || (idx(x) - idx(y)); });
      else a.sort(function (x, y) { return idx(x) - idx(y); });
      return a;
    }
    function matchingTotal(n) {
      // the app knows the true totals: no filter → summary count; star filters only → the distribution counts
      if (!filtered()) return total;
      if (st.stars.length && !st.attr && !st.photos && !st.topic) return bars.reduce(function (s, b) { return s + (st.stars.indexOf(+b.getAttribute('data-rvw-star')) > -1 ? +b.getAttribute('data-count') : 0); }, 0);
      return n;
    }
    function apply(keepFocus) {
      var hit = sorted(cards.filter(matches));
      var rest = sorted(cards.filter(function (c) { return !matches(c); }));
      hit.concat(rest).forEach(function (c) { list.appendChild(c); });
      hit.forEach(function (c, i) { c.hidden = i >= st.limit; });
      rest.forEach(function (c) { c.hidden = true; });
      var shown = Math.min(hit.length, st.limit), of = matchingTotal(hit.length);
      if (countEl) countEl.innerHTML = hit.length ? 'Showing <b>' + fmt(shown) + '</b> of <b>' + fmt(of) + '</b> review' + (of === 1 ? '' : 's') : 'Showing <b>0</b> reviews';
      if (none) none.hidden = hit.length > 0;
      if (moreWrap) moreWrap.hidden = hit.length <= st.limit;
      clearBtns.forEach(function (b) { b.hidden = !filtered() && b !== $('[data-rvw-none] [data-rvw-clear]', sec); });
      if (dist) dist.classList.toggle('has-on', st.stars.length > 0);
      measure();
    }
    function measure() {
      cards.forEach(function (c) {
        if (c.hidden) return;
        var b = $('[data-rvw-body]', c), m = $('[data-rvw-more]', c);
        if (!b || !m || c.classList.contains('is-open')) return;
        m.hidden = !(b.scrollHeight > b.clientHeight + 2);
      });
    }
    function resetLimit() { st.limit = page(); }

    bars.forEach(function (b) {
      b.addEventListener('click', function () {
        var s = +b.getAttribute('data-rvw-star'), i = st.stars.indexOf(s), on = i < 0;
        if (on) st.stars.push(s); else st.stars.splice(i, 1);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        resetLimit(); apply();
        if (!DESK.matches && on) scrollToList();
      });
    });
    function scrollToList() {
      var t = $('.rvw-tools', sec); if (!t) return;
      var y = t.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--hdr-h'), 10) || 56) - 12;
      if (t.getBoundingClientRect().top > window.innerHeight * 0.75) window.scrollTo({ top: y, behavior: RM.matches ? 'auto' : 'smooth' });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var k = c.getAttribute('data-rvw-attr'), on = st.attr !== k;
        st.attr = on ? k : '';
        chips.forEach(function (o) { o.setAttribute('aria-pressed', o === c && on ? 'true' : 'false'); });
        resetLimit(); apply();
      });
    });
    if (photoChip) photoChip.addEventListener('click', function () {
      st.photos = !st.photos; photoChip.setAttribute('aria-pressed', st.photos ? 'true' : 'false'); resetLimit(); apply();
    });
    topics.forEach(function (c) {
      c.addEventListener('click', function () {
        var k = c.getAttribute('data-rvw-topic'), on = st.topic !== k;
        st.topic = on ? k : '';
        topics.forEach(function (o) { o.setAttribute('aria-pressed', o === c && on ? 'true' : 'false'); });
        resetLimit(); apply();
      });
    });
    if (sortSel) sortSel.addEventListener('change', function () { st.sort = sortSel.value; resetLimit(); apply(); });
    function clearAll() {
      st.stars = []; st.attr = ''; st.photos = false; st.topic = '';
      bars.concat(chips, topics, photoChip ? [photoChip] : []).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      resetLimit(); apply();
    }
    clearBtns.forEach(function (b) { b.addEventListener('click', function () { clearAll(); var h = $('.rvw-side > h2', sec); if (h && b.closest('[data-rvw-none]')) h.focus(); }); });
    if (moreBtn) moreBtn.addEventListener('click', function () {
      var before = cards.filter(function (c) { return !c.hidden; }).length;
      st.limit += page(); apply();
      var first = cards.filter(function (c) { return !c.hidden; })[before];
      if (first) first.focus({ preventScroll: true });                    // keyboard users land on the first new review
    });
    list.addEventListener('click', function (e) {
      var m = e.target.closest('[data-rvw-more]');
      if (m) {
        var c = m.closest('.rvw-card'), open = !c.classList.contains('is-open');
        c.classList.toggle('is-open', open);
        m.setAttribute('aria-expanded', open ? 'true' : 'false');
        m.textContent = open ? 'Show less' : 'Read more';
        return;
      }
      var h = e.target.closest('[data-rvw-help]');
      if (h) {
        var on = h.getAttribute('aria-pressed') !== 'true', n = (+h.getAttribute('data-n') || 0) + (on ? 1 : 0);
        h.setAttribute('aria-pressed', on ? 'true' : 'false');
        $('.rvw-help-n', h).textContent = n ? String(n) : '';
        h.classList.toggle('is-zero', !n);
        // theme: POST the vote to the review app here (one vote per visitor; the app de-duplicates)
      }
    });

    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(measure, 150); });
    if (DESK.addEventListener) DESK.addEventListener('change', function () { resetLimit(); apply(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    apply();
    sec._rvw = { apply: apply, clear: clearAll, state: st, reveal: reveal };

    // reveal one card (from the lightbox "Read the full review"): clear filters if needed, page to it, flash it
    function reveal(card) {
      if (!matches(card)) clearAll();
      var hit = sorted(cards.filter(matches)), i = hit.indexOf(card);
      if (i >= st.limit) { st.limit = i + 1; apply(); }
      card.scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth', block: 'start' });
      card.classList.remove('is-flash'); void card.offsetWidth; card.classList.add('is-flash');
      card.focus({ preventScroll: true });
    }
  }

  /* ------------------------------------------------------------ CUSTOMER PHOTOS */
  function initPhotos(sec) {
    sec.setAttribute('data-cph-ready', '');
    var rail = $('[data-cph-rail]', sec), arrows = $('[data-cph-arrows]', sec);
    var prev = $('[data-cph-prev]', sec), next = $('[data-cph-next]', sec);
    var prog = $('.cph-progress', sec), thumb = prog && $('i', prog);
    var sheet = $('.cph-sheet', sec);
    function update() {
      if (!rail) return;
      // a tile covered by the "+N more" overlay is not a second tab stop (the overlay button opens all photos)
      $$('.cph-plus', rail).forEach(function (p) { var t = $('.cph-tile', p.parentNode); if (t) t.tabIndex = getComputedStyle(p).display === 'none' ? 0 : -1; });
      var rail2 = DESK.matches && getComputedStyle(rail).display === 'flex';
      var over = rail2 && rail.scrollWidth > rail.clientWidth + 4;
      if (arrows) arrows.hidden = !over;
      if (prog) prog.style.visibility = over ? 'visible' : 'hidden';
      if (!over) return;
      var max = rail.scrollWidth - rail.clientWidth, x = rail.scrollLeft;
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
      if (thumb) {
        var w = Math.max(12, rail.clientWidth / rail.scrollWidth * 100);
        thumb.style.setProperty('--w', w + '%');
        thumb.style.setProperty('--x', (max ? x / max : 0) * (100 / w * 100 - 100) + '%');
      }
    }
    function step(dir) { rail.scrollBy({ left: dir * rail.clientWidth * 0.84, behavior: RM.matches ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    if (rail) rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    if (sheet) {
      wireDialog(sheet);
      $$('[data-cph-all]', sec).forEach(function (b) { b.addEventListener('click', function () { openDialog(sheet, b); }); });
    }
  }

  /* ------------------------------------------------------------ LIGHTBOX (one per page) */
  var LB = null;
  function buildLightbox() {
    var d = document.createElement('dialog');
    d.className = 'rlb gvb'; d.setAttribute('aria-label', 'Customer photo');
    d.innerHTML =
      '<div class="rlb-in">' +
        '<div class="rlb-stage" data-rlb-stage>' +
          '<img class="rlb-img" alt="" decoding="async">' +
          '<p class="rlb-count" aria-live="polite"></p>' +
          '<button type="button" class="rlb-nav rlb-prev" aria-label="Previous photo"><i>' + ICON.arrow + '</i></button>' +
          '<button type="button" class="rlb-nav rlb-next" aria-label="Next photo"><i>' + ICON.arrow + '</i></button>' +
        '</div>' +
        '<div class="rlb-panel">' +
          '<div class="rlb-meta"><span class="gst" role="img" style="--s:16px"></span><span class="rlb-date"></span></div>' +
          '<p class="rlb-body"></p>' +
          '<p class="rlb-who"><b></b><span class="rlb-city"></span><span class="rvw-ver" hidden>' + ICON.badge + 'Verified buyer</span></p>' +
          '<a class="link rlb-read" href="#">Read the full review</a>' +
          '<a class="rlb-prod" href="#"><span class="rlb-pth"><img alt="" width="88" height="88" decoding="async"></span><span class="rlb-pt"><b></b><span></span></span><span class="btn btn-ink">Shop</span></a>' +
        '</div>' +
        '<button type="button" class="rlb-x" aria-label="Close photo"><i>' + ICON.close + '</i></button>' +
      '</div>';
    document.body.appendChild(d);
    var lb = { d: d, img: $('.rlb-img', d), count: $('.rlb-count', d), prev: $('.rlb-prev', d), next: $('.rlb-next', d),
      st: $('.gst', d), date: $('.rlb-date', d), body: $('.rlb-body', d), name: $('.rlb-who b', d), city: $('.rlb-city', d), ver: $('.rlb-who .rvw-ver', d),
      read: $('.rlb-read', d), prod: $('.rlb-prod', d), pimg: $('.rlb-pth img', d), pname: $('.rlb-pt b', d), pmeta: $('.rlb-pt span', d),
      items: [], i: 0, opener: null, fromCard: null };
    lb.prev.addEventListener('click', function () { show(lb.i - 1); });
    lb.next.addEventListener('click', function () { show(lb.i + 1); });
    $('.rlb-x', d).addEventListener('click', function () { d.close(); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(lb.i - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(lb.i + 1); }
    });
    d.addEventListener('close', function () { lb.img.removeAttribute('src'); var o = lb.opener; if (o && document.contains(o)) o.focus({ preventScroll: true }); });
    // swipe on the photo
    var sx = null, sy = null, stage = $('[data-rlb-stage]', d);
    stage.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') return; sx = e.clientX; sy = e.clientY; });
    stage.addEventListener('pointerup', function (e) {
      if (sx === null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) show(lb.i + (dx < 0 ? 1 : -1));
    });
    lb.read.addEventListener('click', function (e) {
      var card = document.getElementById(lb.read.getAttribute('data-card') || '');
      if (!card) return;
      e.preventDefault(); lb.opener = null; d.close();
      var sec = card.closest('[data-rvw]');
      if (sec && sec._rvw) sec._rvw.reveal(card);
    });
    lb.prod.addEventListener('click', function () {
      // a product row with data-pick selects that tier in the buy box (shared.js listens for this event)
      var it = lb.items[lb.i]; if (it && it.dataset.pick) document.dispatchEvent(new CustomEvent('gvb:pick-tier', { detail: { tier: it.dataset.pick } }));
    });
    function show(i) {
      if (i < 0 || i >= lb.items.length) return;
      lb.i = i;
      var it = lb.items[i], ds = it.dataset;
      lb.img.removeAttribute('srcset');
      if (ds.fullSrcset) { lb.img.setAttribute('srcset', ds.fullSrcset); lb.img.setAttribute('sizes', DESK.matches ? '640px' : '100vw'); }
      lb.img.src = ds.full; lb.img.width = +ds.w || 800; lb.img.height = +ds.h || 800;
      lb.img.alt = ds.alt || (ds.name ? 'Photo shared by ' + ds.name : 'Customer photo');
      lb.count.textContent = lb.items.length > 1 ? (i + 1) + ' / ' + lb.items.length : '';
      lb.count.hidden = lb.items.length < 2;
      lb.prev.disabled = i === 0; lb.next.disabled = i === lb.items.length - 1;
      lb.prev.hidden = lb.next.hidden = lb.items.length < 2;
      var r = +ds.rating || 0;
      lb.st.style.setProperty('--fill', starFill(r) + '%'); lb.st.setAttribute('aria-label', 'Rated ' + r + ' out of 5'); lb.st.hidden = !r;
      lb.date.textContent = ds.date || '';
      lb.body.textContent = ds.body || ''; lb.body.hidden = !ds.body;
      lb.name.textContent = ds.name || ''; lb.city.textContent = ds.city || ''; lb.city.hidden = !ds.city;
      lb.ver.hidden = !('verified' in ds);
      var card = ds.review ? document.getElementById(ds.review) : null;
      lb.read.hidden = !card || card === lb.fromCard;
      if (card) lb.read.setAttribute('data-card', card.id), lb.read.setAttribute('href', '#' + card.id);
      lb.prod.hidden = !ds.pname;
      if (ds.pname) { lb.prod.href = ds.phref || '#'; lb.pname.textContent = ds.pname; lb.pmeta.textContent = ds.pmeta || ''; if (ds.pthumb) { lb.pimg.src = ds.pthumb; lb.pimg.parentNode.hidden = false; } else lb.pimg.parentNode.hidden = true; lb.prod.setAttribute('aria-label', 'Shop ' + ds.pname + (ds.pmeta ? ', ' + ds.pmeta : '')); }
      var nx = lb.items[i + 1]; if (nx) { var pre = new Image(); pre.src = nx.dataset.full; }
    }
    lb.show = show;
    return lb;
  }
  function openLightbox(items, i, opener) {
    if (!LB) LB = buildLightbox();
    LB.items = items; LB.opener = opener; LB.fromCard = opener ? opener.closest('.rvw-card') : null;
    LB.show(i);
    if (typeof LB.d.showModal === 'function') { if (!LB.d.open) LB.d.showModal(); } else LB.d.setAttribute('open', '');
  }
  function onDocClick(e) {
    var it = e.target.closest('[data-rlb-item]');
    if (it) {
      var g = it.closest('[data-rlb-group]'), items = g ? $$('[data-rlb-item]', g) : [it];
      openLightbox(items, items.indexOf(it), it);
      return;
    }
    var ref = e.target.closest('[data-rlb-of]');
    if (ref) {
      var grp = document.querySelector('[data-rlb-group="' + ref.getAttribute('data-rlb-of') + '"]');
      if (!grp) return;
      openLightbox($$('[data-rlb-item]', grp), +ref.getAttribute('data-rlb-index') || 0, ref);
    }
  }

  function init(scope) {
    scope = scope || document;
    $$('[data-rvw]:not([data-rvw-ready])', scope).forEach(initReviews);
    $$('[data-cph]:not([data-cph-ready])', scope).forEach(initPhotos);
    $$('[data-bbr]:not([data-bbr-ready])', scope).forEach(function (a) {
      a.setAttribute('data-bbr-ready', '');
      a.addEventListener('click', function () {
        var h = document.getElementById((a.getAttribute('href') || '').slice(1) + '-h');
        if (h) setTimeout(function () { h.focus({ preventScroll: true }); }, RM.matches ? 0 : 450);   // move focus with the jump
      });
    });
    if (!document.documentElement.hasAttribute('data-rlb-wired')) {
      document.documentElement.setAttribute('data-rlb-wired', '');
      document.addEventListener('click', onDocClick);
    }
  }
  window.gvbReviewsInit = init;
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
